<template>
  <div>
    <v-dialog v-model="updateUserDialog" :persistent="isLoading" max-width="500">
      <v-form @submit.prevent="updateUser()" ref="form" :lazy-validation="true" :disabled="isLoading">
        <v-card>
          <v-card-title class="primary white--text d-flex justify-space-between">{{ $t('account.edit_personal_profile') }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-5">
            <v-text-field
              :label="$t('account.first_name')"
              :placeholder="$t('account.first_name')"
              :rules="[rules.required]"
              v-model="firstName"
              :disabled="isLoading"
              outlined
            ></v-text-field>
            <v-text-field
              :label="$t('account.last_name')"
              :placeholder="$t('account.last_name')"
              :rules="[rules.required]"
              v-model="lastName"
              :disabled="isLoading"
              outlined
            ></v-text-field>
            <v-text-field
              label="email"
              placeholder="email"
              :rules="[rules.emailRule]"
              v-model="email"
              :disabled="isLoading"
              outlined
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              elevation="0"
              @click="updateUserDialog = false"
              :disabled="isLoading"
            >
              <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
            </v-btn>
            <v-btn
              type="submit"
              color="success"
              elevation="0"
              :loading="isLoading"
              :disabled="isLoading"
            >
              <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UpdateUser",
  computed: {
    ...mapGetters({
      getUser: "user/getUser"
    }),
    updateUserDialog: {
      get() {
        if (this.value) {
          this.resetForm();
          this.initData();
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        emailRule: v => /.+@.+/.test(v) || !v || `${this.$t('example')} example@myket.in.th`
      },
      firstName: "",
      lastName: "",
      email: "",
      isLoading: false
    };
  },
  props: {
    value: Boolean
  },
  created() {
  },
  methods: {
    resetForm() {
      this.firstName = "";
      this.lastName = "";
    },
    async initData() {
      if (!this.getUser) {
        await this.getUserInfo();
      }
      if (this.getUser) {
        let { firstName, lastName, email } = this.getUser;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email
      }
    },
    async updateUser() {
      if (this.$refs.form.validate()) {
        try {
          let isChange = false;
          this.isLoading = true;
          if (this.getUser) {
            let { firstName, lastName, email } = this.getUser;
            isChange = firstName !== this.firstName || lastName !== this.lastName || email !== this.email;
          }
          if (isChange) {
            await this.$store.dispatch("user/updateUser", {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email
            });
            this.$toast.show({
              content: this.$t('validate.edit_profile_success'),
              color: "success"
            });
            this.updateUserDialog = false
          } else
            this.$toast.show({
              content: this.$t('validate.data_no_change'),
              color: "warning"
            });
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    async getUserInfo() {
      try {
        this.isLoading = true;
        await this.$store.dispatch("user/getUserInfo");
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.$router.push("/auth/login");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
